import { ReactElement, PropsWithChildren, Children } from "react";
import { Box, Card, Flex } from "@mantine/core";
import { ICustomCardProps } from "./types";
import { useStyles } from "./CustomCard.styled";
import CardTitle from "../CardTitle";

export default function CustomCard({
  borderColor,
  withShadow,
  title,
  extra,
  disabled,
  children,
  ...cardProps
}: PropsWithChildren<ICustomCardProps>): ReactElement {
  const { classes } = useStyles({ borderColor, withShadow, disabled });

  const childrenCount = Children.toArray(children).length;

  return (
    <Card className={classes.root} w="100%" {...cardProps}>
      {(title || extra) && (
        <Flex
          align="center"
          direction="row"
          gap="xs"
          justify="space-between"
          wrap="nowrap"
          mb={childrenCount > 0 ? "xs" : 0}
          mt={-2}
          w="100%"
        >
          {title && <CardTitle>{title}</CardTitle>}
          <Box>{extra}</Box>
        </Flex>
      )}

      {children}
    </Card>
  );
}
